import React, { useMemo } from 'react';
import { AlertTriangle, Link2, Clock, Wrench } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { ForumBase } from '../../types/forum';
import { analyzeScrapeHealth } from '../../utils/scrapeHealth';

interface Props {
  forums: ForumBase[];
}

const ScrapeHealthPanel: React.FC<Props> = ({ forums }) => {
  const issues = useMemo(() => analyzeScrapeHealth(forums), [forums]);
  const noSelector = issues.filter((i) => i.kind === 'no_selector');
  const stale = issues.filter((i) => i.kind === 'stale');
  const noUrl = issues.filter((i) => i.kind === 'no_url');

  if (issues.length === 0) {
    return (
      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg p-4 text-green-800 dark:text-green-200 text-sm">
        Scrape sağlığı iyi görünüyor — kritik sorun yok.
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-4 flex items-center gap-2">
        <AlertTriangle className="text-amber-500" size={20} />
        Scrape sağlığı ({issues.length} uyarı)
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4 text-sm">
        <div className="flex items-center gap-2 text-amber-700 dark:text-amber-300">
          <Wrench size={16} /> Seçici yok: {noSelector.length}
        </div>
        <div className="flex items-center gap-2 text-orange-700 dark:text-orange-300">
          <Clock size={16} /> Eski güncelleme: {stale.length}
        </div>
        <div className="flex items-center gap-2 text-red-700 dark:text-red-300">
          <Link2 size={16} /> URL yok: {noUrl.length}
        </div>
      </div>
      <ul className="max-h-48 overflow-y-auto text-sm space-y-1">
        {issues.slice(0, 20).map((i) => (
          <li key={`${i.id}-${i.kind}`} className="flex justify-between gap-2 text-gray-600 dark:text-gray-400">
            <Link to="/admin/forums" className="text-indigo-600 dark:text-indigo-400 hover:underline truncate">
              {i.name}
            </Link>
            <span className="shrink-0">{i.detail}</span>
          </li>
        ))}
      </ul>
      {issues.length > 20 && (
        <p className="text-xs text-gray-500 mt-2">+{issues.length - 20} daha — Forumlar sayfasından düzeltin.</p>
      )}
    </div>
  );
};

export default ScrapeHealthPanel;
